const BASE_URL = (process.env.REACT_APP_BLOG_BASE_URL || "").replace(/\/+$/, "");
const APPLICATION_NAME = process.env.REACT_APP_APPLICATION_NAME || "";

export const PAGE_SIZE = 9;

const buildUrl = (path, params = {}) => {
  const url = new URL(`${BASE_URL}/api/public/blogs/${path}`);
  url.searchParams.set("application_name", APPLICATION_NAME);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
};

const stripHtml = (html) =>
  String(html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const estimateReadTime = (html) => {
  const words = stripHtml(html).split(" ").filter(Boolean).length;
  return `${Math.max(1, Math.round(words / 200))} min read`;
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

/**
 * Maps an API record onto the shape the blog pages render.
 * The API has no category or excerpt guarantee, so both are derived/optional.
 */
export const normalizeBlog = (raw) => {
  if (!raw) return null;

  return {
    id: raw.slug || String(raw.id),
    slug: raw.slug || String(raw.id),
    title: raw.title || "Untitled",
    subtitle: raw.excerpt || raw.meta_description || "",
    image: raw.thumbnail || "",
    content: raw.body_content || "",
    author: { name: raw.author || "Geo VPN" },
    date: formatDate(raw.published_date || raw.created_at),
    readTime: estimateReadTime(raw.body_content),
    seoTitle: raw.meta_title || raw.title || "",
    seoDescription: raw.meta_description || "",
  };
};

const request = async (url, signal) => {
  const response = await fetch(url, { signal });

  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  const payload = await response.json();
  if (payload && payload.success === false) {
    throw new Error(payload.message || "Request failed");
  }
  return payload;
};

export const fetchBlogs = async ({
  page = 1,
  pageSize = PAGE_SIZE,
  signal,
} = {}) => {
  const payload = await request(
    buildUrl("", { is_published: true, page, page_size: pageSize }),
    signal,
  );

  const records = Array.isArray(payload?.data) ? payload.data : [];
  return {
    blogs: records.map(normalizeBlog).filter(Boolean),
    pagination: payload?.pagination || {
      count: records.length,
      total_pages: 1,
      current_page: page,
    },
  };
};

export const fetchBlogBySlug = async (slugOrId, signal) => {
  if (!slugOrId) return null;
  const payload = await request(
    buildUrl(`${encodeURIComponent(slugOrId)}/`),
    signal,
  );
  return normalizeBlog(payload?.data);
};
